export const onlineChannels = ['ONLINE', 'DEVOLUCAO', 'OMNI'];

export const physicalChannels = [
    'VITRINE',
    'FISICO',
    'SOMASTORE',
    'ESTOQUE PROPRIO',
];
